const diaBrasil = (d: Date) => d.toLocaleDateString('en-CA', { timeZone: 'America/Sao_Paulo' });

/** Dias úteis (segunda a sexta) depois do dia de `iso`, até hoje, no fuso de São Paulo. */
export function diasUteisDesde(iso: string | null | undefined, agora: Date = new Date()): number | null {
  if (!iso) return null;
  const inicio = new Date(iso);
  if (Number.isNaN(inicio.getTime())) return null;
  const hoje = diaBrasil(agora);
  const cursor = new Date(`${diaBrasil(inicio)}T12:00:00Z`);
  let dias = 0;
  for (let i = 0; i < 400; i++) {
    cursor.setUTCDate(cursor.getUTCDate() + 1);
    if (cursor.toISOString().slice(0, 10) > hoje) break;
    const semana = cursor.getUTCDay();
    if (semana !== 0 && semana !== 6) dias++;
  }
  return dias;
}
